<template v-if="item.length > 0">
  <tr>
    <td class="text-center">
      <span class="form-control form-control-plaintext">{{
        rowIndex + 1
      }}</span>
    </td>
    <td class="text-center align-middle">
      {{ item.barcodeNoOld }}<br />({{item.departmentMaterialCode}})
    </td>
    <td class="text-center align-middle">
      {{ item.materialCode }}<br />{{ item.materialName }}
    </td>
    <!-- Begin:column originPlantCode-->
    <!-- <td v-if="item.originPlantCode != null" class="text-center align-middle">
      {{ item.originPlantCode }}<br />{{ item.originPlantName }}
    </td> -->
    <td
      class="text-center align-middle"
      style="background-color:#FB4B6B"
    >
      <select2
        :css-style="'width: 100%;'"
        :css-class="'form-control'"
        :id="'originPlantCode2' + _uid"
        :name="'originPlantCode2' + _uid"
        :select2-options="originPlantOptions"
        ref="originPlantCode2"
        v-model="item.originPlantCode2"
        @selectChange="onOriginPlantChange"
      ></select2>
    </td>
    <!-- End:column : originPlantCode-->

    <!-- Begin:column destinationAgentCode-->
    <td
      v-if="item.destinationAgentCode != null"
      class="text-center align-middle"
    >
      {{ item.destinationAgentCode }}<br />{{ item.destinationAgentName }}
    </td>
    <td
      v-else
      class="text-center align-middle"
      style="background-color:#FB4B6B"
    ></td>
    <!-- End:column destinationAgentCode-->

    <!-- Begin:column cnStatusName-->
    <td
      v-if="item.cnStatusCode == 'CN_STATUS_BY_OTHER'"
      class="text-center align-middle"
      style="color:#EB355E"
    >
      {{ item.cnStatusName }}
    </td>
    <td v-else class="text-center align-middle">{{ item.cnStatusName }}</td>
    <!-- End:column cnStatusName-->

    <!-- Begin:column cnToAgentCode-->
    <td v-if="item.cnToAgentCode != null" class="text-center align-middle">
      {{ item.cnToAgentCode }}<br />{{ item.cnToAgentName }}
    </td>
    <td
      v-else
      class="text-center align-middle"
      style="background-color:#FB4B6B"
    ></td>
    <!-- End:column cnToAgentCode-->
    <!-- <td v-if="item.cnToAgentCode2 != null" class="text-center align-middle">{{item.cnToAgentCode2}}<br>{{item.cnToAgentName2}}</td> -->
    <td class="text-center align-middle">
      <select2
        :css-style="'width: 100%;'"
        :css-class="'form-control'"
        :id="'cnToAgentCode2' + _uid"
        :name="'cnToAgentCode2' + _uid"
        :select2-options="cnToAgentOptions"
        ref="cnToAgentCode2"
        v-model="item.cnToAgentCode2"
        @selectChange="onCnToAgentCode2Change"
      ></select2>
    </td>
  </tr>
</template>
<script>
import select2 from "../../Shared/Select2";

export default {
  components: {
    select2,
  },
  props: {
    rowIndex: Number,
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    var self = this;
    return {
      originPlantCode: null,
      originPlantCode2: null,
      destinationAgentCode: null,
      destinationAgentCode2: null,
      cnToAgentCode2: null,
      originPlantOptions: {
        placeholder: "กรุณาเลือกคลังสินค้าที่จ่ายออก",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/Plant/PlantOptions",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      destinationAgentOptions: {
        placeholder: "กรุณาเลือกตัวแทนฯที่ได้รับจากคลังสินค้า",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2SearchAgentName",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              department: [],
              province_id: [],
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      cnToAgentOptions: {
        placeholder: "เลือกCN ให้(ตัวแทนฯ)",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2SearchAgentName",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              department: [],
              province_id: [],
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  methods: {
    onOriginPlantChange: function(id, text, data, ref) {
      var self = this;
      if (data.length != 0) {
        self.item.originPlantText = data[0].text;
        //console.log("data", text);
        //console.log(self.item);
      } else {
        self.item.originPlantText = "";
      }
    },
    onCnToAgentCode2Change: function(id, text, data, ref) {
      var self = this;
      if (data.length != 0) {
        self.item.cnToAgentText2 = data[0].text;
        self.item.cnToAgentName2 = data[0].agenT_NAME;
        //console.log("data", text);
        //console.log(self.item);
      } else {
        self.item.cnToAgentText2 = "";
      }
    },
  },
  mounted() {
    // $(".required", this.$el).each(function() {
    //   const $input = $(this);
    //   $input.rules("add", {
    //     required: true,
    //     messages: {
    //       required: $input.data("msg-required"),
    //     },
    //   });
    // });
    // $(".min", this.$el).each(function() {
    //   const $input = $(this);
    //   $input.rules("add", {
    //     min: true,
    //     messages: {
    //       min: $input.data("msg-min"),
    //     },
    //   });
    // });
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Job/JobCNItemRow.vue